import * as ng from 'angular';
import * as _ from 'underscore';

ng.module('e360')
   .directive('validated', validatedDirective);

validatedDirective.$inject = [];
export function validatedDirective():ng.IDirective {
   return {
      restrict: 'A',
      link: validatedDirectiveLinkFn,
      require: 'ngModel'
   };
}

function validatedDirectiveLinkFn(scope, element, attrs, ngModelCtrl:ng.INgModelController) {
   let keys = [];
   let suppressed = [];

   if (attrs.suppressMessagesFor) {
      suppressed = attrs.suppressMessagesFor.split(',');
   }

   if (attrs.validated.length > 0) {
      keys = attrs.validated.split(',');
   } else {
      let modelName:string = attrs.ngModel;

      let propParts = modelName.split('.');

      // remove known controllerAs prefix
      if (_.contains(['ctrl', 'vm', '$ctrl'], propParts[0])) {
         propParts.shift();
      }

      // server does not include root model name in error keys
      if (propParts.length > 1) {
         propParts.shift();
      }

      modelName = propParts.join('.');

      keys.push(modelName);
   }

   scope.$on('form.valid', onFormValid);
   scope.$on('form.invalid', onFormInvalid);

   function getInputElement() {
      if (element.is('input,select,textarea,button,.form-control')) {
         return element;
      }

      //some inputs are wrapped by other elements, such as datepicker.
      return element.find('.form-control,.btn.event-selector');
   }

   function onFormValid($event) {
      let inputElement = getInputElement();
      let formGroup = inputElement.closest('.form-group');

      formGroup.find('div.error-message').remove();
      inputElement.removeClass('invalid');
      ngModelCtrl.$setValidity('server-validated', true);
   }

   function onFormInvalid($event, errors) {
      let inputElement = getInputElement();
      let formGroup = inputElement.closest('.form-group');

      formGroup.find('div.error-message').remove();
      inputElement.removeClass('invalid');
      ngModelCtrl.$setValidity('server-validated', true);

      if (errors && errors.length > 0) {
         _.each(keys, function (key) {
            let error = _.findWhere(errors, {field: key}) as any;
            if (error) {
               let isSuppressed = _.any(suppressed, function (s) {
                  return s === key;
               });
               if (!isSuppressed) {
                  let errorDiv = `<div class="error-message">${error.message}</div>`;
                  formGroup.append(errorDiv);
               }
               inputElement.addClass('invalid');
               ngModelCtrl.$setValidity('server-validated', false);
            }
         });
      }
   }
}
